// extracted by mini-css-extract-plugin
module.exports = {"chart-iframe":"styles-m__chart-iframe__15CfI"};